import Button, { ButtonProps } from '@mui/material/Button';

interface NereusButtonProps extends ButtonProps {

}


const NereusButton: React.FC<NereusButtonProps> = (props) => {
    // Apply the textTransform none style while respecting any sx props passed.
    const { sx, ...otherProps } = props;

    return (
        <Button
            {...otherProps}
            sx={{ textTransform: 'none' }}
        />
    );
};

export default NereusButton;